<script>
import RightLayout from '../layouts/rightLayout'
import dialog from '@/components/Dialog'
import { formatDate } from '@/utils/date.js'
import { StringUtil } from '@/utils/StringUtil.js'
import axios from 'axios'
export default {
  components: {
    // dialog 弹出框组件
    'v-dialog': dialog,
    RightLayout},
  data () {
    return {
      chooseResult: {
        // 会員数
        memberNumber: false,
        // 車両
        vehicle: false,
        // 管理者
        administrator: false,
        // ドライバー
        driver: false,
        // 利用人数
        usePersonNumber: false,
        // 利用件数
        userThingNumber: false,
        // 利用金額
        userCost: false,
        // 運行便情報
        movementShiftInfo: false,
        // 停留所
        station: false,
        // ルート
        route: false,
        // 予約状況
        reserveSituation: false,
        // 予約手段
        reserveWay: false,
        // 性別・年齢層
        sexAge: false,
        // 利用回数
        useCount: false,
        // 交通事業者区分
        transportKind: 0,
        // 交通事業者ID
        transportId: null
      },
      dataTitle: {
        // 登録会員
        loginUser: false,
        // 運行管理
        movementManagement: false,
        // 運行実績
        movementWork: false,
        // 予約詳細
        reserveDetail: false,
        // 利用者詳細
        userDetail: false
      },
      loading: false,
      timer: 0,
      // message提示弹出框配置信息
      showDialog: false,
      dialogOption: {
        showNo: false,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      allChooseFlag: false,
      exportStartDate: new Date(),
      exportEndDate: new Date(),
      exportStartTime: '',
      exportEndTime: '',
      transportKind: 0,
      // 交通事業者選択
      transportSelect: '',
      // 交通事業者一覧
      transportInfoList: [],
      // 交通事業者ID
      transportId: null
    }
  },
  created () {
    // 交通事業者一覧取得
    this.getTransportInfoList()
  },
  watch: {
    transportKind (newvalue) {
      this.transportKind = newvalue
      if (newvalue === 0) {
        this.transportId = null
      }
    },
    // 交通事業者選択
    transportSelect (newvalue) {
      this.transportId = newvalue
    }
  },
  methods: {
    allChoose () {
      if (this.allChooseFlag === true) {
        for (let i in this.chooseResult) {
          this.chooseResult[i] = true
        }
      } else if (this.allChooseFlag === false) {
        for (let i in this.chooseResult) {
          this.chooseResult[i] = false
        }
      }
    },
    // 出力开始结束时间校验
    startEndTimeValidate () {
      // 结束时间小于开始时间
      if (this.exportEndDate < this.exportStartDate) {
        // 错误message提示
        this.showMessage('出力期間の入力月の順序が不正です。')
        return false
      }
      // 将date格式转化为yyyyMM格式
      this.exportStartTime = formatDate(this.exportStartDate, 'yyyyMM')
      // 将date格式转化为yyyyMM格式
      this.exportEndTime = formatDate(this.exportEndDate, 'yyyyMM')
      return true
    },
    // 交通事業者の選択チェック
    selectTransportIDValidate () {
      // 区域外を選択した場合は、交通事業者を選択しているか
      if (this.transportKind === '1' && (this.transportId === null)) {
        // メッセージを表示
        this.showMessage('区域外を選択した場合は、交通事業者を選択してください')
        return false
      }
      // this.showMessage(this.transportId)
      return true
    },
    // 至少选个一个checkbox的校验
    atLeastOneCheckBox () {
      for (let i in this.chooseResult) {
        if (this.chooseResult[i] === true) {
          return true
        }
      }
      this.showMessage('出力項目を選択してください。')
      return false
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOption.text = title
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    // 标题下是否有checkbox被选中判断（给后台使用）
    getDataTitle () {
      // 登録会員
      if (this.chooseResult.memberNumber === false) {
        this.dataTitle.loginUser = false
      } else {
        this.dataTitle.loginUser = true
      }
      // 運行管理
      if (this.chooseResult.vehicle === false &&
      this.chooseResult.administrator === false &&
      this.chooseResult.driver === false
      ) {
        this.dataTitle.movementManagement = false
      } else {
        this.dataTitle.movementManagement = true
      }
      // 運行実績
      if (this.chooseResult.usePersonNumber === false &&
      this.chooseResult.userThingNumber === false &&
      this.chooseResult.userCost === false &&
      this.chooseResult.movementShiftInfo === false &&
      this.chooseResult.station === false &&
      this.chooseResult.route === false
      ) {
        this.dataTitle.movementWork = false
      } else {
        this.dataTitle.movementWork = true
      }
      // 予約詳細
      if (this.chooseResult.reserveSituation === false &&
      this.chooseResult.reserveWay === false
      ) {
        this.dataTitle.reserveDetail = false
      } else {
        this.dataTitle.reserveDetail = true
      }
      // 利用者詳細
      if (this.chooseResult.sexAge === false &&
      this.chooseResult.useCount === false
      ) {
        this.dataTitle.userDetail = false
      } else {
        this.dataTitle.userDetail = true
      }
    },
    submit () {
      if (this.startEndTimeValidate()) {
        if (this.selectTransportIDValidate()) {
          if (this.atLeastOneCheckBox()) {
            this.getDataTitle()
            this.commitToServer()
          }
        }
      }
    },
    async commitToServer () {
      this.loading = true
      let requestId = ''
      this.chooseResult.transportKind = this.transportKind
      if (this.chooseResult.transportKind === '1') {
        this.chooseResult.transportId = this.transportId
      } else {
        this.chooseResult.transportId = null
      }
      let requestParam = {
        exportStartTime: this.exportStartTime,
        exportEndTime: this.exportEndTime,
        dataTitle: this.dataTitle,
        chooseResult: this.chooseResult
      }
      let rec = await this.$axios
        .post('statistics/requestStatistics', requestParam)
      requestId = rec.data.requestId
      if (!StringUtil.isEmpty(requestId)) {
        let count = 0
        this.timer = setInterval(() => {
          // 统计执行次数
          count = count + 1
          // 查看CSV数据是否加载成功
          let param = new URLSearchParams()
          param.append('requestId', requestId)
          // 如果请求时间超过五分钟
          if (count >= 150) {
            // 清除计时器
            clearInterval(this.timer)
            this.loading = false
            this.showMessage('リクエストした処理がタイムアウトしました。')
          }
          this.$axios
            .post('statistics/queryCSVSuccess', param).then((response) => {
              // 1 执行中  2 完成  3 异常
              if (response.data.status === 2) {
                // 清除计时器
                clearInterval(this.timer)
                this.downloadCSV(requestId)
              } else if (response.data.status === 3) {
                // 清除计时器
                clearInterval(this.timer)
                this.loading = false
                this.showMessage('予期せぬエラーが発生しました。')
              }
            })
        }, 2000)
      }
    },
    // download CSV
    downloadCSV (requestId) {
      let param = new URLSearchParams()
      param.append('requestId', requestId)
      axios({
        method: 'post',
        url: 'statistics/downloadCSV',
        data: param,
        responseType: 'blob'
      }).then(response => {
        let url = window.URL.createObjectURL(new Blob([response.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '月次実績集計.csv')
        document.body.appendChild(link)
        link.click()
        this.loading = false
      }).catch((error) => {
        console.log(error)
      })
    },
    // 返回上一层
    goback () {
      this.$router.go(-1)
    },
    // 交通事業者一覧取得
    getTransportInfoList () {
      this.$axios
        .get('user/getTransportInfoList', {
          params: {}
        })
        .then(response => {
          this.transportInfoList = response.data.transportInfoList
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<template>
<right-layout>
    <div class="col-md-12 column" style="width:100%;display:flex;flex-direction: column;flex:1" v-loading="loading"  element-loading-text="ただいま処理中です。しばらくお待ちください。">
        <div class="row clearfix" style="flex: 0 0 40px">
            <div class="col-md-12 column T7-title">月次実績集計</div>
            <div class="col-md-12 column F3-R-18" style="margin-top:20px">
                ※出力したいデータの項目をチェックボックスで指定してください。
            </div>
        </div>
        <div class="row clearfix slider" style="flex: 1;display:flex;">
            <div style="flex: 0 0 180px">
            </div>
            <div style="flex: 1">
                <div class="clearfix" style="padding-top:30px;">
                     <div class="col-md-2 column titleDiv divTitle bgc8 F3-R-15">
                        出力期間
                     </div>
                     <div class="col-md-4 column shortInput">
                        <el-date-picker
                         type="month"
                         v-model="exportStartDate"
                         prefix-icon = "null"
                         :editable = false
                         :clearable = false
                         format="yyyy年M月"
                         style="width:100%;">
                        </el-date-picker>
                    </div>
                    <div class="col-md-2 column divTitle clearPadding" style="width:20px">
                        ～
                    </div>
                    <div class="col-md-4 column shortInput">
                        <el-date-picker
                         type="month"
                         v-model="exportEndDate"
                         prefix-icon = "null"
                         :editable = false
                         :clearable = false
                         format="yyyy年M月"
                         style="width:100%;">
                        </el-date-picker>
                    </div>
                </div>
                <div class="clearfix" style="padding-top:30px;">
                  <div class="col-md-2 column titleDiv divTitle bgc8 F3-R-15">
                    運行区分
                  </div>
                  <div v-if="type=='block'" class="col-md-9 column">
                      <div v-if="transportKind==0" class="F3-R-20 bgc5 blockedDiv">区域内</div>
                      <div v-if="transportKind==1" class="F3-R-20 bgc5 blockedDiv">区域外</div>
                  </div>
                  <div v-else class="col-md-9 column radiodiv textAlignLeft shortInput">
                    <label class="radio-inline" style="margin-right: 4%">
                      <input class="radiobutton" type="radio" name="transportKindRadio" v-model="transportKind" value="0">
                      <span></span>
                      <span class="F3-R-20">区域内</span>
                    </label>
                    <label class="radio-inline">
                      <input class="radiobutton" type="radio" name="transportKindRadio" v-model="transportKind" value="1">
                      <span></span>
                      <span class="F3-R-20">区域外</span>
                    </label>
                  </div>
                </div>
                <!-- 交通事業者名 -->
                <div class="clearfix" style="padding-top:30px;" v-show="transportKind == 1">
                  <div class="col-md-2 column titleDiv divTitle bgc8 F3-R-15">
                    交通事業者名
                  </div>
                  <div class="col-md-4 column shortInput">
                    <select class="selectstyles selectImg F3-R-20" name="selectTransport" v-model="transportSelect" :disabled="type=='block'">
                      <option v-for='item in transportInfoList' :key="item.transportId" :value="item.transportId">
                        {{item.transportName}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="clearfix F3-R-20 textAlignLeft" style="padding-top:20px;">
                    <input type="checkbox" class="btn btn-default checkboxStyle" v-model="allChooseFlag" @change="allChoose"/>
                    <span>全選択/全解除</span>
                </div>
                <div class="clearfix" style="margin-top:30px;">
                     <div class="col-md-2 column shortDiv">
                         <div class="row clearfix textAlignLeft">
                            <span class="F3-R-20" style="font-weight:bold !important">登録会員</span>
                         </div>
                         <div class="row clearfix F3-R-20 textAlignLeft divMarginTop">
                             <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.memberNumber"/>
                             <span>会員数</span>
                         </div>
                     </div>
                     <div class="col-md-2 column shortDiv">
                         <div class="row clearfix textAlignLeft">
                             <span class="F3-R-20" style="font-weight:bold !important">運行管理</span>
                         </div>
                         <div class="row clearfix F3-R-20 textAlignLeft divMarginTop">
                             <div class="clearfix F3-R-20">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.vehicle"/>
                                <span>車両</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.administrator"/>
                                <span>管理者</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.driver"/>
                                <span>ドライバー</span>
                             </div>
                         </div>
                     </div>
                     <div class="col-md-2 column shortDiv">
                         <div class="row clearfix textAlignLeft">
                             <span class="F3-R-20" style="font-weight:bold !important">運行実績</span>
                         </div>
                         <div class="row clearfix F3-R-20 textAlignLeft divMarginTop">
                             <div class="clearfix F3-R-20">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.usePersonNumber"/>
                                <span>利用人数</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.userThingNumber"/>
                                <span>利用件数</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.userCost"/>
                                <span>利用金額</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.movementShiftInfo"/>
                                <span>運行便情報</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.station"/>
                                <span>停留所</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.route"/>
                                <span>ルート</span>
                             </div>
                         </div>
                     </div>
                     <div class="col-md-2 column shortDiv">
                         <div class="row clearfix textAlignLeft">
                             <span class="F3-R-20" style="font-weight:bold !important">予約詳細</span>
                         </div>
                         <div class="row clearfix F3-R-20 textAlignLeft divMarginTop">
                             <div class="clearfix F3-R-20">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.reserveSituation"/>
                                <span>予約状況</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.reserveWay"/>
                                <span>予約手段</span>
                             </div>
                         </div>
                     </div>
                     <div class="col-md-2 column shortDiv">
                         <div class="row clearfix textAlignLeft">
                             <span class="F3-R-20" style="font-weight:bold !important">利用者詳細</span>
                         </div>
                         <div class="row clearfix F3-R-20 textAlignLeft divMarginTop">
                             <div class="clearfix F3-R-20">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.sexAge"/>
                                <span>性別・年齢層</span>
                             </div>
                             <div class="clearfix F3-R-20 divMarginTop">
                                <input type="checkbox" class="btn btn-default checkboxStyle" v-model="chooseResult.useCount"/>
                                <span>利用回数</span>
                             </div>
                         </div>
                     </div>
                </div>
            </div>
            <div style="flex: 0 0 180px">
            </div>
        </div>
        <div class="row clearfix" style="margin-top:10px;margin-bottom:30px;">
            <div class="col-md-6 column" style="text-align:right">
              <button class="window-button" style="width: 70%;" @click="submit">出力</button>
            </div>
            <div class="col-md-6 column" style="text-align:left">
              <button class="window-button" style="width: 70%;" @click="goback">キャンセル</button>
            </div>
        </div>
        <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
    </div>
</right-layout>
</template>

<style scoped>
.T7-title {
  margin-top: 25px;
  font-size: 25px;
  color: black;
}
.titleDiv {
  width: 13%;
  min-width: 120px;
}
.shortDiv {
  width: 20%;
  min-width: 120px;
}
.divTitle {
  height: 50px;
  line-height: 50px;
}
.shortInput {
  width: 35%;
}
.clearPadding {
  padding-left: 0;
  padding-right: 0;
}
.checkboxStyle{
  height: 30px;
  width: 30px;
}
.divMarginTop {
  margin-top: 10px;
}
.textAlignLeft{
  text-align:left;
}
.textAlignRight{
  text-align: right;
}
.radiodiv {
  border-radius: 10px;
  width: 250px;
  height: 45px;
  margin-top: 5px;
  text-align: center;
  font-size: 18px;
}
.radiobutton {
  height: 30px;
  width: 30px;
}
input[type="radio"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
.selectstyles {
  border: solid 1px #ccc;
  width: 100%;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
  padding-left: 12px;
  background-color: white !important;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
  -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../../assets/dropselect.png") no-repeat scroll right center transparent;
}
.errorMessage {
  color: red;
}
.errorDiv{
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/ .el-input__inner{
  font-family: 'Noto Sans CJK JP' !important;
  color: rgb(80, 80, 80) !important;
  font-size: 20px !important;
  font-weight: 400 !important;
  height: 50px;
  padding-left: 12px;
  border-radius: 0;
  border: 1px solid #ccc;
  background: url("../../assets/dropselect.png") no-repeat scroll right center transparent;
}
</style>



// WEBPACK FOOTER //
// src/router/views/MonthWorkCount.vue